import { callAuthorizedGraphQLEndpoint } from '../../../Module/graphQL'
import { shouldFetchActiveDates } from './utils'

const getClientById = clientId => {
  const query = `
    query ($clientId: ID!){
        clients(clientId: $clientId){
           nodes{
                id
                name
                status
                logo
                code
                tags{
                    id
                    value
                    type
                    tagLinkId
                    }
           }
        }
       getTags(type: CLIENT){
            edges {
                 node {
                    id
                    value
                    type
                 }
            }
       }
    }
  `
  const params = { clientId }
  return callAuthorizedGraphQLEndpoint(query, params)
}

const getCampaigns = ({ clientIds, statuses }) => {
  const query = `query getCampaigns ($clientIds:[ID!],$statuses: [CampaignStatusEnum!]) {
    campaigns(clientIds: $clientIds, statuses:$statuses){
       edges {
          node {
            id
            name
            type
            status
            ${
              shouldFetchActiveDates(statuses)
                ? `
                      activeDates{
                        start
                        end
                      }`
                : ''
            }
            cityPlans {
              nodes{
                id
              }
            }
          }
        }
    }
  }`
  const params = { clientIds, statuses }

  return callAuthorizedGraphQLEndpoint(query, params)
}

export { getClientById, getCampaigns }



// WEBPACK FOOTER //
// ./src/Containers/Clients/ClientView/gql.js